import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail } from 'lucide-react';
export function About() {
  return <div className="w-full min-h-screen bg-[#F6F6F6] px-4 md:px-8 py-8 md:py-16" data-id="element-195">
      <div className="max-w-4xl mx-auto" data-id="element-196">
        <Link to="/stats" className="inline-flex items-center gap-2 mb-8 text-purple hover:text-yellow transition-colors duration-100" data-id="element-197">
          <ArrowLeft className="w-5 h-5" data-id="element-198" />
          <span className="font-display uppercase tracking-wide text-sm font-bold" data-id="element-199">
            Volver a Estadísticas
          </span>
        </Link>

        {/* Hero Section */}
        <div className="bg-yellow border-brutal border-[#1A1A1A] rounded-none shadow-[8px_8px_0px_0px_rgba(91,43,224,1)] p-6 md:p-12 mb-10 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[6px_6px_0px_0px_rgba(91,43,224,1)] transition-all duration-100" data-id="element-200">
          <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-purple uppercase tracking-tight mb-4" data-id="element-201">
            ¿Qué es "(Not) Parásitos"?
          </h1>
          <p className="text-base md:text-lg text-[#1A1A1A] leading-relaxed" data-id="element-202">
            "(Not) Parásitos" es una iniciativa destinada a democratizar la
            información pública. A través de esta página ponemos a disposición
            estadísticas sobre la labor de los diputados para que la ciudadanía
            pueda informarse con datos reales y verificables.
          </p>
        </div>

        {/* Main Content Sections */}
        <div className="space-y-10" data-id="element-203">
          {/* Mission */}
          <div className="bg-white border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(26,26,26,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transition-all duration-100" data-id="element-204">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-yellow pb-2" data-id="element-205">
              Nuestra Misión
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed" data-id="element-206">
              Creemos que la labor parlamentaria es un pilar del sistema
              democrático: es un trabajo importante y serio que, como cualquier
              otro, debe ejercerse con responsabilidad, transparencia y
              rendición de cuentas. Nuestro objetivo no es atacar a personas,
              sino aportar información clara que permita a las y los ciudadanos
              evaluar el desempeño de sus representantes.
            </p>
          </div>

          {/* Editorial Line */}
          <div className="bg-lavender border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(91,43,224,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(91,43,224,1)] transition-all duration-100" data-id="element-207">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-purple pb-2" data-id="element-208">
              Nuestra Línea Editorial
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-4" data-id="element-209">
              Nos guiamos por algunos principios simples:
            </p>
            <ul className="space-y-3" data-id="element-210">
              <li className="flex items-start gap-3" data-id="element-211">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-212">
                  →
                </span>
                <div data-id="element-213">
                  <strong className="text-purple" data-id="element-214">Transparencia:</strong> usar
                  exclusivamente fuentes públicas y explicitar cómo calculamos
                  cada indicador.
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-215">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-216">
                  →
                </span>
                <div data-id="element-217">
                  <strong className="text-purple" data-id="element-218">Responsabilidad:</strong>{' '}
                  contextualizar los datos, evitando conclusiones simplistas o
                  sensacionalistas.
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-219">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-220">
                  →
                </span>
                <div data-id="element-221">
                  <strong className="text-purple" data-id="element-222">Independencia:</strong> no
                  pertenecemos a ningún partido político ni recibimos
                  instrucciones editoriales de organizaciones partidistas.
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-223">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-224">
                  →
                </span>
                <div data-id="element-225">
                  <strong className="text-purple" data-id="element-226">
                    Desmontar discursos engañosos:
                  </strong>{' '}
                  aportar información clara y verificable que permita
                  identificar y contrarrestar mentiras, exageraciones, discursos
                  manipulados o charlatanería.
                </div>
              </li>
            </ul>
          </div>

          {/* Why These Stats */}
          <div className="bg-white border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(26,26,26,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transition-all duration-100" data-id="element-227">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-yellow pb-2" data-id="element-228">
              ¿Por qué mostrar estas estadísticas?
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-4" data-id="element-229">
              La asistencia a sesiones, el tiempo en sala y otros indicadores no
              son detalles menores: forman parte del compromiso mínimo que una
              persona asume al ocupar un cargo de representación. Al visibilizar
              esta información:
            </p>
            <ul className="space-y-3" data-id="element-230">
              <li className="flex items-start gap-3" data-id="element-231">
                <span className="text-yellow text-2xl flex-shrink-0 font-bold" data-id="element-232">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-233">
                  Facilitamos que la ciudadanía haga seguimiento al desempeño de
                  sus representantes.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-234">
                <span className="text-yellow text-2xl flex-shrink-0 font-bold" data-id="element-235">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-236">
                  Contribuimos a la conversación pública sobre la calidad de la
                  representación política.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-237">
                <span className="text-yellow text-2xl flex-shrink-0 font-bold" data-id="element-238">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-239">
                  Promovemos una cultura de responsabilidad y servicio público,
                  en la que la labor parlamentaria se entiende como un trabajo
                  serio, al igual que el de cualquier otro trabajador o
                  trabajadora del país.
                </span>
              </li>
            </ul>
          </div>

          {/* Data Source */}
          <div className="bg-yellow border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(91,43,224,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(91,43,224,1)] transition-all duration-100" data-id="element-240">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-purple pb-2" data-id="element-241">
              ¿De dónde sacamos la información?
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-4" data-id="element-242">
              Todos los datos que mostramos provienen de registros públicos
              oficiales. Actualmente, utilizamos información de transparencia
              publicada por la Cámara de Diputadas y Diputados de Chile,
              obtenida al 100% desde su sitio oficial (camara.cl):
            </p>
            <ul className="space-y-2 mb-4" data-id="element-243">
              <li className="flex items-start gap-3" data-id="element-244">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-245">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-246">
                  Información de asistencia, inasistencia y justificaciones.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-247">
                <span className="text-purple text-2xl flex-shrink-0 font-bold" data-id="element-248">
                  →
                </span>
                <span className="text-base text-[#1A1A1A]" data-id="element-249">
                  Horarios de inicio de sesión y registro de ingreso de los
                  parlamentarios.
                </span>
              </li>
            </ul>
            <p className="text-base text-[#1A1A1A] leading-relaxed" data-id="element-250">
              No utilizamos ni mostramos datos privados ni información obtenida
              por vías no oficiales.
            </p>
          </div>

          {/* Limitations */}
          <div className="bg-white border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(26,26,26,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transition-all duration-100" data-id="element-251">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-yellow pb-2" data-id="element-252">
              Limitaciones y alcances de los datos
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-6" data-id="element-253">
              Para ser transparentes, es importante explicitar qué sí y qué no
              podemos hacer con los datos disponibles.
            </p>

            <div className="space-y-6" data-id="element-254">
              {/* Tiempo en sesión */}
              <div className="bg-[#F6F6F6] border-2 border-purple p-4 rounded-none" data-id="element-255">
                <h3 className="font-display text-lg font-bold text-purple uppercase mb-3" data-id="element-256">
                  Tiempo en sesión
                </h3>
                <ul className="space-y-2" data-id="element-257">
                  <li className="flex items-start gap-3" data-id="element-258">
                    <span className="text-purple text-xl flex-shrink-0" data-id="element-259">•</span>
                    <span className="text-base text-[#1A1A1A]" data-id="element-260">
                      Calculamos el "tiempo en sesión" considerando únicamente
                      la hora oficial de ingreso a la sesión registrada por la
                      Cámara.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-261">
                    <span className="text-purple text-xl flex-shrink-0" data-id="element-262">•</span>
                    <span className="text-base text-[#1A1A1A]" data-id="element-263">
                      De momento no contamos con la hora de salida de cada
                      diputada o diputado, por lo que asumimos como supuesto que
                      la persona permanece en la sala hasta el final de la
                      sesión. Esto puede sobreestimar el tiempo real de
                      presencia en algunos casos.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Atrasos */}
              <div className="bg-[#F6F6F6] border-2 border-purple p-4 rounded-none" data-id="element-264">
                <h3 className="font-display text-lg font-bold text-purple uppercase mb-3" data-id="element-265">
                  Atrasos
                </h3>
                <ul className="space-y-2" data-id="element-266">
                  <li className="flex items-start gap-3" data-id="element-267">
                    <span className="text-purple text-xl flex-shrink-0" data-id="element-268">•</span>
                    <span className="text-base text-[#1A1A1A]" data-id="element-269">
                      Definimos un atraso como una asistencia a sesión con hora
                      de ingreso igual o superior a 15 minutos después de la
                      hora de inicio programada.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-270">
                    <span className="text-purple text-xl flex-shrink-0" data-id="element-271">•</span>
                    <span className="text-base text-[#1A1A1A]" data-id="element-272">
                      Esta es una regla de cálculo definida por nosotros para
                      estandarizar las estadísticas y puede diferir de otros
                      criterios utilizados por terceros.
                    </span>
                  </li>
                </ul>
              </div>

              {/* Inasistencias justificadas */}
              <div className="bg-[#F6F6F6] border-2 border-purple p-4 rounded-none" data-id="element-273">
                <h3 className="font-display text-lg font-bold text-purple uppercase mb-3" data-id="element-274">
                  Inasistencias justificadas
                </h3>
                <ul className="space-y-2 mb-3" data-id="element-275">
                  <li className="flex items-start gap-3" data-id="element-276">
                    <span className="text-purple text-xl flex-shrink-0" data-id="element-277">•</span>
                    <span className="text-base text-[#1A1A1A]" data-id="element-278">
                      No toda ausencia implica falta de compromiso. Muchas
                      inasistencias se consideran "justificadas" porque el o la
                      parlamentaria se encuentra cumpliendo otras funciones
                      oficiales o atravesando situaciones personales relevantes.
                    </span>
                  </li>
                </ul>
                <p className="text-base text-[#1A1A1A] leading-relaxed mb-2" data-id="element-279">
                  Entre los motivos se incluyen, por ejemplo:
                </p>
                <ul className="space-y-2 ml-6 mb-3" data-id="element-280">
                  <li className="flex items-start gap-3" data-id="element-281">
                    <span className="text-yellow text-lg flex-shrink-0" data-id="element-282">→</span>
                    <span className="text-sm text-[#1A1A1A]" data-id="element-283">
                      Actividades propias de la labor parlamentaria (comisiones,
                      misiones oficiales, gestiones encomendadas, etc.).
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-284">
                    <span className="text-yellow text-lg flex-shrink-0" data-id="element-285">→</span>
                    <span className="text-sm text-[#1A1A1A]" data-id="element-286">
                      Misiones oficiales dentro o fuera del país.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-287">
                    <span className="text-yellow text-lg flex-shrink-0" data-id="element-288">→</span>
                    <span className="text-sm text-[#1A1A1A]" data-id="element-289">
                      Licencias médicas y permisos parentales.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-290">
                    <span className="text-yellow text-lg flex-shrink-0" data-id="element-291">→</span>
                    <span className="text-sm text-[#1A1A1A]" data-id="element-292">
                      Permisos personales regulados por la normativa laboral o
                      parlamentaria.
                    </span>
                  </li>
                </ul>
                <ul className="space-y-2" data-id="element-293">
                  <li className="flex items-start gap-3" data-id="element-294">
                    <span className="text-purple text-xl flex-shrink-0" data-id="element-295">•</span>
                    <span className="text-base text-[#1A1A1A]" data-id="element-296">
                      En nuestra página simplificamos estos motivos para mostrar
                      una visión general de las inasistencias justificadas.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-297">
                    <span className="text-purple text-xl flex-shrink-0" data-id="element-298">•</span>
                    <span className="text-base text-[#1A1A1A]" data-id="element-299">
                      El detalle completo de cada justificación puede
                      consultarse directamente en los registros de la Cámara de
                      Diputadas y Diputados en su sitio web oficial.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-300">
                    <span className="text-purple text-xl flex-shrink-0" data-id="element-301">•</span>
                    <span className="text-base text-[#1A1A1A]" data-id="element-302">
                      <strong data-id="element-303">Inasistencias totales:</strong> suma de
                      inasistencias justificadas + injustificadas.
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-6 bg-yellow border-brutal border-[#1A1A1A] p-5 rounded-none shadow-[4px_4px_0px_0px_rgba(91,43,224,1)]" data-id="element-304">
              <p className="text-base text-[#1A1A1A] leading-relaxed font-medium" data-id="element-305">
                <strong className="text-purple font-bold" data-id="element-306">En resumen:</strong>{' '}
                Nuestros gráficos y estadísticas son una representación fiel de
                los datos públicos disponibles, pero no siempre capturan toda la
                complejidad del trabajo parlamentario. Para interpretar
                correctamente un caso particular, recomendamos complementar esta
                información con las fuentes originales de la Cámara.
              </p>
            </div>
          </div>

          {/* Top 10 Methodology */}
          <div className="bg-lavender border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(91,43,224,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(91,43,224,1)] transition-all duration-100" data-id="element-307">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-purple pb-2" data-id="element-308">
              ¿Cómo construimos los "Top 10"?
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-4" data-id="element-309">
              Los rankings ("Top 10") de atrasos, inasistencias totales e
              inasistencias injustificadas se ordenan según las cifras oficiales
              de cada categoría. Sin embargo, en caso de empate entre dos o más
              diputados, aplicamos un criterio adicional para ordenar de manera
              consistente:
            </p>
            <div className="bg-yellow border-brutal border-[#1A1A1A] p-5 rounded-none shadow-[4px_4px_0px_0px_rgba(91,43,224,1)]" data-id="element-310">
              <p className="text-base text-[#1A1A1A] leading-relaxed font-medium" data-id="element-311">
                <strong className="text-purple font-bold" data-id="element-312">
                  Criterio de desempate:
                </strong>{' '}
                Cuando dos diputados tienen la misma cantidad de atrasos,
                inasistencias totales o inasistencias injustificadas, ubicamos
                primero a quien tiene menos minutos efectivos en sesión durante
                el período analizado. Esto permite que el ranking refleje no
                solo las ausencias o atrasos, sino también el nivel de presencia
                real en sala.
              </p>
            </div>
          </div>

          {/* Special Indicators */}
          <div className="bg-white border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(26,26,26,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transition-all duration-100" data-id="element-313">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-yellow pb-2" data-id="element-314">
              Indicadores especiales de ausencias prolongadas
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-6" data-id="element-315">
              Para facilitar la interpretación de los datos, marcamos con un
              emoji ciertos casos en los que un diputado presenta ausencias
              justificadas prolongadas dentro del periodo visualizado. Estos
              casos suelen corresponder a situaciones excepcionales reguladas
              por ley o por decisiones judiciales:
            </p>

            <div className="space-y-4" data-id="element-316">
              <div className="flex items-start gap-4 bg-[#F6F6F6] border-2 border-yellow p-4 rounded-none" data-id="element-317">
                <span className="text-4xl flex-shrink-0" data-id="element-318">👶</span>
                <div data-id="element-319">
                  <h3 className="font-display text-base font-bold text-purple uppercase mb-2" data-id="element-320">
                    Permisos parentales (prenatal / postnatal)
                  </h3>
                  <p className="text-sm text-[#1A1A1A] leading-relaxed" data-id="element-321">
                    Mostramos este ícono junto al nombre cuando, dentro del
                    rango de fechas consultado, el diputado registró una o más
                    inasistencias justificadas debido a permisos parentales
                    (prenatal, postnatal o postnatal parental). Estos permisos
                    están protegidos por ley y pueden extenderse durante varias
                    semanas o meses.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-[#F6F6F6] border-2 border-yellow p-4 rounded-none" data-id="element-322">
                <span className="text-4xl flex-shrink-0" data-id="element-323">🚨</span>
                <div data-id="element-324">
                  <h3 className="font-display text-base font-bold text-purple uppercase mb-2" data-id="element-325">
                    Desaforado por la justicia
                  </h3>
                  <p className="text-sm text-[#1A1A1A] leading-relaxed" data-id="element-326">
                    Este ícono aparece cuando el diputado tuvo una o más
                    inasistencias justificadas debido a un proceso de desafuero
                    dictado por tribunales. El desafuero puede impedir
                    temporalmente que un parlamentario ejerza plenamente sus
                    funciones, lo que genera ausencias extendidas.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Glossary */}
          <div className="bg-yellow border-brutal border-[#1A1A1A] rounded-none shadow-[6px_6px_0px_0px_rgba(91,43,224,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[4px_4px_0px_0px_rgba(91,43,224,1)] transition-all duration-100" data-id="element-327">
            <h2 className="font-display text-xl md:text-2xl font-bold text-purple uppercase mb-4 border-b-2 border-purple pb-2" data-id="element-328">
              Glosario básico
            </h2>
            <p className="text-base text-[#1A1A1A] leading-relaxed mb-4" data-id="element-329">
              Para hacer más entendible la información, aquí van algunas
              definiciones simples:
            </p>
            <dl className="space-y-4" data-id="element-330">
              <div className="bg-white border-2 border-purple p-3 rounded-none" data-id="element-331">
                <dt className="font-display font-bold text-purple uppercase text-sm mb-1" data-id="element-332">
                  Sesión
                </dt>
                <dd className="text-base text-[#1A1A1A] leading-relaxed" data-id="element-333">
                  Reunión formal de la Cámara donde se discuten proyectos de
                  ley, se votan mociones y se tratan otros asuntos de la agenda
                  legislativa.
                </dd>
              </div>
              <div className="bg-white border-2 border-purple p-3 rounded-none" data-id="element-334">
                <dt className="font-display font-bold text-purple uppercase text-sm mb-1" data-id="element-335">
                  Asistencia
                </dt>
                <dd className="text-base text-[#1A1A1A] leading-relaxed" data-id="element-336">
                  Presencia registrada de un diputado o diputada en una sesión.
                </dd>
              </div>
              <div className="bg-white border-2 border-purple p-3 rounded-none" data-id="element-337">
                <dt className="font-display font-bold text-purple uppercase text-sm mb-1" data-id="element-338">
                  Inasistencia justificada
                </dt>
                <dd className="text-base text-[#1A1A1A] leading-relaxed" data-id="element-339">
                  Ausencia en una sesión que cuenta con una razón reconocida
                  oficialmente (por ejemplo, misión oficial, licencia médica,
                  permiso parental u otras actividades propias de la función
                  parlamentaria).
                </dd>
              </div>
              <div className="bg-white border-2 border-purple p-3 rounded-none" data-id="element-340">
                <dt className="font-display font-bold text-purple uppercase text-sm mb-1" data-id="element-341">
                  Atraso
                </dt>
                <dd className="text-base text-[#1A1A1A] leading-relaxed" data-id="element-342">
                  Ingreso a la sesión con posterioridad a la hora oficial de
                  inicio. En nuestras estadísticas, consideramos atraso cuando
                  el ingreso se registra 15 minutos o más después del inicio.
                </dd>
              </div>
              <div className="bg-white border-2 border-purple p-3 rounded-none" data-id="element-343">
                <dt className="font-display font-bold text-purple uppercase text-sm mb-1" data-id="element-344">
                  Desafuero parlamentario
                </dt>
                <dd className="text-base text-[#1A1A1A] leading-relaxed" data-id="element-345">
                  Mecanismo jurídico mediante el cual un tribunal puede
                  autorizar que un parlamentario sea sometido a proceso penal,
                  levantando la protección especial que tiene por su cargo. El
                  detalle de cada caso puede revisarse en las fuentes oficiales
                  del Poder Judicial o del Congreso.
                </dd>
              </div>
            </dl>
          </div>

          {/* Contact */}
          <div className="bg-purple border-brutal border-[#1A1A1A] rounded-none shadow-[8px_8px_0px_0px_rgba(255,217,61,1)] p-6 md:p-8 transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[6px_6px_0px_0px_rgba(255,217,61,1)] transition-all duration-100" data-id="element-346">
            <h2 className="font-display text-xl md:text-2xl font-bold text-yellow uppercase mb-4" data-id="element-347">
              ¡Hablemos!
            </h2>
            <p className="text-base text-white leading-relaxed mb-4" data-id="element-348">
              Si tienes dudas, comentarios, quieres reportar un error o proponer
              mejoras, puedes escribirnos a:
            </p>
            <a href="mailto:contacto.parasitos@gmail.com" className="inline-flex items-center gap-2 bg-yellow text-purple font-display uppercase text-xs sm:text-sm font-bold px-4 sm:px-6 py-3 border-2 border-[#1A1A1A] hover:bg-white hover:shadow-[0_0_8px_rgba(255,217,61,0.8)] transition-all duration-100 break-all" data-id="element-349">
              <Mail className="w-5 h-5 flex-shrink-0" data-id="element-350" />
              <span className="break-all" data-id="element-351">
                contacto.parasitos@protonmail.com
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>;
}